<template lang="pug">
  //- CONTENT TEMPLATE
  conteudo#conteudo(v-if='!loading' ref="principal")
    header(slot="header")
      titulo {{ titulo }}
      p {{ subtitulo }}
      p.data {{ data }}
      br
    .texto(slot="content")
      cover(v-if="imagem", :imagem="imagem", :legenda="imagemCaption")
      .text(v-html='corpo')
    footer(slot="footer")
      p(v-if='autor').autor Autor: {{ autor }}
      p(v-if='fonte').autor Fonte: {{ fonte }}
      ul.anexos(v-if="anexos.length")
        li.item(v-for="anexo of anexos", :key="anexo.id"): a.link(:href="anexo.url" target="_blank") {{ anexo.nome }}
      tags(v-if="tags.length", :itens="tags")
      back-and-share
  //- LOADING TEMPLATE
  conteudo(v-else)
    span.sr-only Carregando...
    .loading-container.conteudo-loading(slot="loading")
      .item.header
        .titulo.animated
        .subtitulo.animated
        .date.animated
      .item.texto
        .slot.animated.cover
        .slot
          .paragraph.animated.full
          .paragraph.animated.full
          .paragraph.animated.three-quarter
          .paragraph.animated.middle
        .slot
          .paragraph.animated.full
          .paragraph.animated.full
          .paragraph.animated.three-quarter
          .paragraph.animated.middle
</template>

<style lang="scss" scoped>

.data {
  position: relative;
  display: inline-block;
  padding-bottom: 10px;
}

.data:after {
  content: '';
  position: absolute;
  top: 100%;
  right: 0;
  left: 0;
  width: 80%;
  height: 4px;
  border-radius: 7px;
  background-color: $color-blue-dark;
}

.autor {
  font-weight: bold;
  &:first-child {
    margin-bottom: 0;
  }
}

.anexos {
  margin: 30px 0;
  > .item {
    display: block;
    > .link { @include transition }
    > .link { color: $color-grey-normal }
    > .link:focus,
    > .link:hover { color: $color-green-dark }
    &:before {
      content: '\f0c6';
      font-family: 'FontAwesome';
      color: $color-green-dark;
      margin-right: 15px;
    }
  }
}

.tags { margin: 30px auto; }

</style>

<script>
import BackAndShare from 'COMPONENTS/BackAndShare'
import Cover from 'COMPONENTS/ImagemCover'
import Conteudo from 'COMPONENTS/Conteudo'
import Tags from 'COMPONENTS/Tags'
import Titulo from 'COMPONENTS/ContentTitle'
import NoticiasService from '../../js/api/NoticiaService'
import Utils from '../../js/utils'

import * as config from '../../js/config'

export default {
  components: {
    BackAndShare,
    Cover,
    Conteudo,
    Tags,
    Titulo
  },
  methods: {
    loadNoticia (id) {
      NoticiasService.getNoticia(id)
      .then(noticia => {
        this.id = noticia.id
        this.titulo = noticia.title.rendered
        this.subtitulo = noticia.acf.subtitulo
        this.imagem = (noticia.featured_media) ? Utils.trataImagemFull(noticia._embedded['wp:featuredmedia'][0]).source_url : false
        this.imagemCaption = (noticia.featured_media) ? noticia._embedded['wp:featuredmedia'][0].caption.rendered : false
        this.data = Utils.dataFormatada(noticia.acf.data_de_publicacao * 1000)
        let tagsAtual = []
        if (noticia.tags.length > 0) {
          noticia._embedded['wp:term'][0].forEach(function (term) {
            tagsAtual.push({
              id: term.id,
              nome: term.name,
              slug: term.slug
            })
          })
          this.tags = tagsAtual
        }
        let documentosAtuais = []
        if (noticia.acf.documentos.length) {
          noticia.acf.documentos.forEach(function (documento) {
            documentosAtuais.push({
              id: documento.id,
              nome: documento.title.rendered,
              url: documento.acf.arquivo
            })
          })
          this.anexos = documentosAtuais
        }

        this.autor = noticia.acf.autor
        this.fonte = noticia.acf.origem
        this.corpo = noticia.acf.corpo

        this.loading = false
      })
    },
    getAsyncData: function () {
      var self = this
      window.setTimeout(function () {
        self.titulo = self.titulo
        self.$emit('updateHead')
      }, 3000)
    }
  },
  data: function () {
    return {
      loading: true,
      titulo: '',
      subtitulo: '',
      imagem: '',
      corpo: '',
      data: '',
      tags: [],
      anexos: [],
      autor: '',
      fonte: ''
    }
  },
  mounted: function () {
    this.loadNoticia(this.$route.params.id)
    this.getAsyncData()
  },
  head: {
    title: function () {
      return {
        inner: config.SITE_TITLE + ' - ' + this.titulo
      }
    },
    meta: function () {
      return [
        { name: 'description', content: config.SITE_DESC + ' - ' + this.titulo, id: 'description' },
        { p: 'og:title', c: config.SITE_TITLE + ' - ' + this.titulo },
        { p: 'og:image', c: this.imagem },
        { p: 'og:description', c: config.SITE_DESC + ' - ' + this.titulo }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Noticia.vue?93d54652